import { objectSchemaOf, Joi } from '../helpers';

export interface IUpdateParams {
  conversationId: string;
  comment: string;
}

export const updateParamsSchema = objectSchemaOf<IUpdateParams>({
  conversationId: Joi.string().required(),
  comment: Joi.string().required().allow(''),
});

export interface IApi {
  conversationReviewsUpdate(params: IUpdateParams): Promise<void>;
}
